import { useParams, useSearchParams } from "react-router-dom";
import LoanSimulatorFlanders from "./LoanSimulatorFlanders";
import LoanSimulatorGirona from "./LoanSimulatorGirona";

export default function LoanSimulator() {
  const { region } = useParams();
  const [searchParams] = useSearchParams();
  const flow = searchParams.get("flow"); // "classic" or "guided"

  if (region === "flanders") return <LoanSimulatorFlanders flow={flow} />;
  if (region === "girona")   return <LoanSimulatorGirona flow={flow} />;
}